import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import SchoolSelector from './schoolLanding/SchoolSelector';
import { useLanguageProvider, langContext } from './api/Lang';

function App() {
    const [lang, setLang] = useLanguageProvider();

    // Listen for language changes from the HTML page
    useEffect(() => {
        const handleLanguageChange = (event: CustomEvent) => {
            setLang(event.detail.lang);
        };

        // Listen for language change events
        window.addEventListener('languageChanged', handleLanguageChange as EventListener);

        return () => {
            window.removeEventListener('languageChanged', handleLanguageChange as EventListener);
        };
    }, [setLang]);

    return (
        <langContext.Provider value={[lang, setLang]}>
            <SchoolSelector />
        </langContext.Provider>
    );
}

const container = document.getElementById('schoolSelector');
if (container) {
    const root = createRoot(container);
    root.render(<App />);
}

// Default export to fix Sentry warning
export default {}; 